export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 — Encuentra productos, QC y guía de compra',
  'hero.h1': 'USFans Spreadsheet — Encuentra productos, revisa el QC y compra mejor',
  'hero.subtitle': 'Explora USFans Spreadsheet con guías prácticas, categorías de productos, consejos de QC, información de envío, consejos de seguridad y los recursos de compra más recientes — todo organizado en un solo lugar.',
  'hero.usfansSpreadsheet': 'USFans Spreadsheet',
  'hero.buyNow': 'Comprar ahora',
  'hero.startGuide': 'Empezar con la guía para principiantes',
  'hero.trust': 'Recurso independiente • Actualizado regularmente • Multilingüe',
  'hero.microcopy': '¿Buscas enlaces de USFans Spreadsheet? Empieza aquí. Explora categorías, entiende el QC, compara opciones y aprende qué revisar antes de hacer un pedido.',
  'hero.dropdownLabel': 'Elige una categoría para abrir',

  'categories.title': 'Categorías de USFans Spreadsheet',
  'categories.subtitle': 'Explora productos por categoría y salta directamente a lo que buscas.',
  'categories.open': 'Abrir',

  'what.title': '¿Qué es USFans Spreadsheet?',
  'what.body': 'USFans Spreadsheet es una forma cómoda de descubrir y organizar enlaces de productos, categorías e información de compra. En lugar de buscar entre publicaciones y enlaces dispersos, nuestro centro de recursos reúne la información más útil en una experiencia estructurada y fácil de buscar.',
  'what.cta': 'Explorar la guía del Spreadsheet',

  'guides.title': 'Todo lo que necesitas saber sobre USFans',
  'guides.subtitle': 'Guías prácticas sobre los temas que más preguntan los compradores.',
  'guides.spread.title': 'USFans Spreadsheet',
  'guides.spread.desc': 'Encuentra y comprende los recursos del spreadsheet.',
  'guides.review.title': 'Reseña de USFans',
  'guides.review.desc': 'Descubre qué deberían considerar los compradores antes de usar la plataforma.',
  'guides.shipping.title': 'Costo de envío de USFans',
  'guides.shipping.desc': 'Entiende los factores que afectan los costos de envío internacional.',
  'guides.coupon.title': 'Cupón de USFans',
  'guides.coupon.desc': 'Descubre cómo funcionan los cupones, promociones y códigos de descuento.',
  'guides.warehouse.title': 'Almacén de USFans',
  'guides.warehouse.desc': 'Entiende el almacenamiento, la inspección y la preparación de paquetes.',
  'guides.legit.title': '¿USFans es legítimo?',
  'guides.legit.desc': 'Lee nuestra guía práctica de seguridad y legitimidad.',

  'why.title': '¿Por qué usar nuestro recurso de USFans Spreadsheet?',
  'why.item1': 'Guías fáciles de seguir',
  'why.item2': 'Navegación clara por categorías',
  'why.item3': 'Educación sobre QC',
  'why.item4': 'Explicaciones de envío',
  'why.item5': 'Información de seguridad',
  'why.item6': 'Tablas comparativas',
  'why.item7': 'Tutoriales para principiantes',
  'why.item8': 'Actualizaciones regulares de contenido',

  'startHere.title': 'Empieza aquí',
  'startHere.subtitle': '¿Nuevo en USFans? Sigue nuestra ruta para principiantes:',
  'startHere.step1': 'Entiende USFans Spreadsheet',
  'startHere.step2': 'Encuentra productos',
  'startHere.step3': 'Revisa la información del producto',
  'startHere.step4': 'Entiende el QC',
  'startHere.step5': 'Aprende sobre el envío',
  'startHere.step6': 'Revisa las consideraciones de seguridad',
  'startHere.step7': 'Continúa al sitio web principal',
  'startHere.cta': 'Leer la guía completa para principiantes',

  'safety.title': 'La seguridad primero',
  'safety.body': 'Un enlace del spreadsheet no es garantía de calidad del producto, fiabilidad del vendedor, seguridad del pago ni entrega. Verifica siempre la información antes de hacer un pedido.',
  'safety.cta': 'Leer la guía de seguridad de USFans',

  'teaser.title': 'Últimas guías de USFans',
  'teaser.subtitle': 'Guías frescas y originales escritas para ayudarte a comprar mejor.',
  'teaser.category': 'Guía',
  'teaser.cardTitle': 'USFans Spreadsheet: guía completa de hallazgos, QC y compras',
  'teaser.cardDesc': 'Aprende qué es USFans Spreadsheet, cómo usarlo, cómo revisar el QC, entender el envío y mantenerte seguro antes de comprar.',
  'teaser.date': 'Actualizado agosto 2026',

  'faq.title': 'Preguntas frecuentes',
  'faq.q1': '¿Qué es USFans Spreadsheet?',
  'faq.a1': 'USFans Spreadsheet es un recurso estructurado que organiza enlaces de productos, categorías e información de compra en un solo lugar. Ayuda a los compradores a descubrir productos más rápido en lugar de buscar entre publicaciones dispersas.',
  'faq.q2': '¿Cómo funciona USFans Spreadsheet?',
  'faq.a2': 'Agrupa productos en categorías y ofrece enlaces, guías y listas de verificación. Exploras una categoría, revisas la información del producto y los detalles de QC, y luego continúas al sitio web principal para hacer el pedido.',
  'faq.q3': '¿USFans es legítimo?',
  'faq.a3': 'Muchos compradores usan USFans como punto de partida para encontrar productos, pero un enlace por sí solo no garantiza calidad ni fiabilidad. Verifica siempre los datos del vendedor, las reseñas y la seguridad del pago antes de comprar.',
  'faq.q4': '¿Cuánto cuesta el envío de USFans?',
  'faq.a4': 'El costo de envío depende del peso del paquete, el destino y la ruta que elijas. Los paquetes más pesados y las rutas más rápidas cuestan más. Revisa las tarifas actuales en el sitio web principal antes de comprar.',
  'faq.q5': '¿USFans ofrece cupones?',
  'faq.a5': 'Las promociones y los códigos de descuento pueden aparecer de vez en cuando. Revisa el sitio web principal y los canales oficiales para conocer las últimas ofertas, y verifica siempre las condiciones y fechas de vencimiento.',
  'faq.q6': '¿Qué es el almacén de USFans?',
  'faq.a6': 'El almacén es donde se guardan, inspeccionan y preparan los productos para el envío. Entender este proceso te ayuda a saber qué ocurre con tu pedido antes de enviarlo.',
  'faq.q7': '¿Cómo reviso el QC?',
  'faq.a7': 'El QC (control de calidad) implica revisar las fotos, medidas y estado del producto antes del envío. Compara las fotos de QC con la publicación y haz preguntas si algo no está claro.',
  'faq.q8': '¿Este sitio web está afiliado oficialmente a USFans?',
  'faq.a8': 'No. Este es un recurso informativo independiente y no está afiliado, respaldado ni patrocinado por USFans. Ofrecemos guías útiles, pero no vendemos productos ni gestionamos pedidos.',

  'finalCta.title': '¿Listo para explorar?',
  'finalCta.subtitle': 'Empieza con USFans Spreadsheet y usa nuestras guías para tomar mejores decisiones.',
  'finalCta.button': 'Explorar USFans Spreadsheet',

  'pillars.title': 'Guías principales de USFans',
  'pillars.subtitle': 'Guías detalladas sobre los temas más importantes antes de comprar.',
  'pillars.readMore': 'Leer más',
  'pillars.p1.title': 'Guía completa de USFans Spreadsheet',
  'pillars.p1.desc': 'Todo lo que necesitas saber para encontrar productos, revisar el QC y usar el spreadsheet.',
  'pillars.p2.title': 'Reseña de USFans',
  'pillars.p2.desc': 'Qué deberían considerar los compradores antes de usar la plataforma.',
  'pillars.p3.title': 'Costo de envío de USFans',
  'pillars.p3.desc': 'Cómo el peso, el destino y la ruta afectan los costos de envío internacional.',
  'pillars.p4.title': 'Cupones de USFans',
  'pillars.p4.desc': 'Cómo funcionan los cupones, promociones y códigos de descuento.',
  'pillars.p5.title': 'Códigos de descuento de USFans',
  'pillars.p5.desc': 'Dónde encontrar y cómo usar los códigos de descuento de forma segura.',
  'pillars.p6.title': 'Almacén de USFans',
  'pillars.p6.desc': 'Cómo funcionan el almacenamiento, la inspección y la preparación de paquetes.',
  'pillars.p7.title': '¿USFans es legítimo?',
  'pillars.p7.desc': 'Una mirada práctica a la seguridad y legitimidad antes de comprar.',
  'pillars.p8.title': 'Guía de seguridad de USFans',
  'pillars.p8.desc': 'Cómo evitar riesgos y comprar con confianza.',
  'pillars.p9.title': 'Guía de QC de USFans',
  'pillars.p9.desc': 'Cómo leer las fotos de QC y revisar las medidas.',
  'pillars.p10.title': 'Guía de compra de USFans',
  'pillars.p10.desc': 'Un camino paso a paso desde la búsqueda hasta el pedido.',
};